// extracted by mini-css-extract-plugin
var _1 = "SearchLinkSelectOption-module__searchLink--qJWGc";
export { _1 as "searchLink" }
